<template>
  <AppHeader>Commission Summary</AppHeader>

  <FromToDate @filter="getData"></FromToDate>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <div class="responsive-table" v-if="data.length != 0">
      <table>
        <thead>
          <tr>
            <th>Date</th>
            <th>Deliveries</th>
            <th>Commissions</th>
            <th>Milk (1L)</th>
            <th>Milk (500ml)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><b>Total</b></td>
            <td><b>{{ total.totalDeliveries }}</b></td>
            <td><b>{{ toInr(total.totalCommission) }}</b></td>
            <td><b>{{ total['2'] }}</b></td>
            <td><b>{{ total['3'] }}</b></td>
          </tr>
          <tr v-for="date in data" :key="date.date">
            <td>{{ date.date }}</td>
            <td>{{ date.totalDeliveries }}</td>
            <td>{{ toInr(date.totalCommission) }}</td>
            <td>{{ date['2'] }}</td>
            <td>{{ date['3'] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="text-center text-gray-500" v-else>
      <p>Please select From & To date to filter</p>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';
import FromToDate from '@/components/common/FromToDate.vue';

export default {
  name: 'ReportCommission',
  mixins: [ mixin ],
  components: { AppHeader, Loading, FromToDate },
  data() {
    return {
      state: 'idle',
      data: [],
      total: {},
    }
  },

  methods: {
    getData(from, to) {
      this.state = 'loading';

      this.request('GET', 'reports/commission?from=' + from + '&to=' + to, {}, (resp) => {
        this.state = 'idle';
        if (resp.success) this.calculateTotal(resp.data);
        else alert(resp.message);
      });
    },

    calculateTotal(data) {
      let total = {totalDeliveries: 0, totalCommission: 0, 2: 0, 3: 0 };
      data.forEach((date) => {
        total['totalDeliveries'] += date['totalDeliveries'];
        total['totalCommission'] += date['totalCommission'];
        total['2'] += date['2'];
        total['3'] += date['3'];
      });

      this.data = data;
      this.total = total;
    },
  },

  created() {
    if (!this.$store.state.api_token) this.$router.push('/');
  }
}
</script>
